export default __webpack_public_path__ + "static/media/sidekick-logo.44867c78.svg";